import { render } from "./SimpleDate.vue?vue&type=template&id=04c9ee1a&scoped=true"
import script from "./SimpleDate.vue?vue&type=script&lang=js"
export * from "./SimpleDate.vue?vue&type=script&lang=js"

import "./SimpleDate.vue?vue&type=style&index=0&id=04c9ee1a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c9ee1a"]])

export default __exports__